import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import banerImage from 'images/detail-of-crop-banner.jpg';
import ProductSidebar from 'components/ProductSidebar';
import PictureComponent from 'components/PictureComponent';
import image from 'images/crop-nutrition-programs-info.jpg';
import { data } from 'components/ProductSidebar/mockData';
import { processingData } from './mockData';
import BenefitsCards from 'components/BenefitsCards';

const DetailedOfCropNutrition = () => {
    return (
        <div className="container">
            <Banner title="Cereals" image={banerImage} buttonText="View program" />
            <div className="inner-container section-padding-y">
                <WithSidebar
                    mobileReversed
                    Sidebar={<ProductSidebar title="Nutrition program for other crops" data={data} />}
                >
                    <div className="box">
                        <PictureComponent srcBig={image} className="pb-24" />
                        <h3>Purpose of processing</h3>
                        <BenefitsCards data={processingData} />
                    </div>
                </WithSidebar>
            </div>
        </div>
    );
};

export default DetailedOfCropNutrition;
